<template>
  <div class="page-wrapper commissions-wrap">
    <div class="container-fluid">
      <commission-projected @onRepSelect="getAll" />
      <div class="page-title">
        <h1 class="pt-4">Monthly Commission Report</h1>
      </div>

      <!-- Tabs Wrapper -->
      <b-tabs content-class="" class="custom-tabs mt-3 commission-table-wrap">
        <!-- Tab 1: Monthly Commission -->
        <b-tab title="Premium Commission">
          <div class="new-table-card prime-table ">
            <div class="table-header">
              <h5 class="">Premium Commissions</h5>
            </div>
            <pagination :rows.sync="rows" class="mb-3" />
            <simple-table :columns="columns">
              <template v-slot:tableBody>
                <commission-table :rows.sync="rows" />
              </template>
            </simple-table>
            <pagination :rows.sync="rows" class="mb-3" />
          </div>
        </b-tab>
        <!-- Tab 2: Other Commissions -->
        <b-tab title="Other Commissions">
          <div class="new-table-card">
            <div class="table-header">
              <h5 class="">Other Commissions</h5>
            </div>
            <pagination :rows.sync="other_rows" class="mb-3" />
            <simple-table :columns="othersColumns">
              <template v-slot:tableBody>
                <commission-other-table :rows2.sync="other_rows" />
              </template>
            </simple-table>
            <pagination :rows.sync="other_rows" class="mb-3" />
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import Api from "@/resource/Api";
import CommissionProjected from "./CommissionProjected.vue";
import CommissionTable from "./partials/CommissionTable.vue";
import CommissionOtherTable from "./partials/CommissionOtherTable.vue";
export default {
  name: "CommissionList",
  components: {
    CommissionTable,
    CommissionProjected,
    CommissionOtherTable,
  },
  data: () => ({
    rows: [],
    other_rows: [],
    columns: [
      { label: "Month Year#" },
      { label: "Direct Comm." },
      { label: "Downline Comm." },
      { label: "Total Comm." },
      { label: "Total Commissions Paid" },
      { label: "Status" },
      { label: "Actions" },
    ],
    othersColumns: [
      { label: "Agent" },
      { label: "Special Way" },
      { label: "One Time" },
      { label: "Association" },
      { label: "Overall Amount" },
      { label: "Month-Year" },
      { label: "Payment Status" },
    ],
    repId: "",
  }),
  methods: {
    getAll(repId) {
      this.repId = repId;
      let loader = this.$loading.show();
      const url =
        repId == null || repId == ""
          ? "v2/commission/get"
          : `v2/commission/get?agent_id=${repId}`;
      const url2 =
        repId == null || repId == ""
          ? "v2/commission/get-others"
          : `v2/commission/get-others?agent_id=${repId}`;
      Api.get(url)
        .then((res) => {
          this.rows = res.data;
        })
        .catch(() => {
          this.rows = [];
        })
        .finally(() => {
          loader.hide();
        });
      Api.get(url2)
        .then((res) => {
          this.other_rows = res.data;
        })
        .catch(() => {
          this.other_rows = [];
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
  created() {
    this.getAll();
    this.getDownlineReps();
  },
  watch: {
    rows(value) {
      if (value) {
        this.rows.path += `?agent_id=${this.repId}`;
      }
    },
  },
};
</script>

<style src="@/assets/css/commissions.css"></style>